module.exports = __webpack_public_path__ + "static/media/city2.b44931fe.jpg";